export const validation = {
  contentMaxChar: 60,
  countMaxChar: 50,
  titlemaxChar: 30
}
